export default class ProdutoMaterial {
	constructor(
        nome='',
		valor=0,
        quantidade_produtos=0,
        valor_por_produto=0,
        produto_id=null
	){
        this.nome = nome;
		this.valor = valor;
        this.quantidade_produtos = quantidade_produtos;
        this.valor_por_produto = valor_por_produto;
        this.produto_id = produto_id;
	}
}